import { INDETERMINATE_STATUS } from '@/consts/app'

/**
 * Clé descriptive pour déterminer le slug d'un service
 * @type {string}
 */
export const SERVICE_SLUG = 'reference'

/**
 * Identity slug
 * @type {string[]}
 */
export const SERVICE_COMMON_IDENTITY = ['activityType.id', 'site.id', 'specialty.id', 'startAt', 'endAt']

/**
 * Identity pour un circuit
 */
export const SERVICE_CIRCUIT_COMMON_IDENTITY = ['startAt', 'endAt']

/**
 * Propriétés communes à plusieurs services
 * @type {string[]}
 */
export const SERVICE_COMMON_PROPERTIES = SERVICE_COMMON_IDENTITY.map((s) => s.split('.')[0])

/**
 * Clé descriptive pour les events d'un service
 * @type {string}
 */
export const SERVICE_EVENTS = 'serviceEvents'

export const SERVICE_ACTIVITY_TYPE_ID_GARDIENNAGE = 1
export const SERVICE_ACTIVITY_TYPE_ID_INTERVENTION = 2
export const SERVICE_ACTIVITY_TYPE_ID_PC = 3

export const SERVICE_CIRCUIT_OVERLAP = 'Service en chevauchement'

export const SERVICE_ACTIVITY_TYPE_LIST = [
  {
    id: SERVICE_ACTIVITY_TYPE_ID_GARDIENNAGE,
    name: `Gardiennage & Surveillance`,
    icon: 'fa fa-eye',
    onlyService: false
  },
  {
    id: SERVICE_ACTIVITY_TYPE_ID_INTERVENTION,
    name: `Intervention & Levée de doute`,
    icon: 'fa fa-running',
    onlyService: false
  },
  {
    id: SERVICE_ACTIVITY_TYPE_ID_PC,
    name: `PC sécurité & Contrôle d'accès`,
    icon: 'fa fa-door-open',
    onlyService: true
  }
]

export const SERVICE_ACTIVITY_TYPE_GARDIENNAGE = SERVICE_ACTIVITY_TYPE_LIST.find((t) => t.id === SERVICE_ACTIVITY_TYPE_ID_GARDIENNAGE)

export const SERVICE_INDEXED_ACTIVITY_TYPE_LIST = _.keyBy(SERVICE_ACTIVITY_TYPE_LIST, 'id')

/**
 * Spé cynophile
 * @type {{label: string, value: string}}
 */
export const SPECIALTY_CYNOPHILE = { value: 'cynophile', label: 'Cynophile' }

export const STATUS_PENDING = 100
export const STATUS_LATE = 110
export const STATUS_NOT_REALIZED = 120
export const STATUS_IN_PROGRESS = 200
export const STATUS_FINISHED = 300
export const STATUS_INTERRUPTED = 400
export const STATUS_PAUSED = 500
export const STATUS_ARCHIVED = 600
export const STATUS_UNPROGRAMMED = 700
export const STATUS_NOT_FINISHED = 800

export const BREAK_NOT_STARTED = 100
export const BREAK_IN_PROGRESS = 200
export const BREAK_NOT_FINISHED = 30
export const BREAK_FINISHED = 400

export const SERVICE_STATUS_LIST = [
  {
    value: STATUS_PENDING,
    slug: 'STATUS_PENDING',
    label: 'En attente',
    color: 'yellow',
    textColor: 'black'
  },
  {
    value: STATUS_LATE,
    slug: 'STATUS_LATE',
    label: 'En retard',
    color: 'yellow',
    textColor: 'black'
  },
  {
    value: STATUS_NOT_REALIZED,
    slug: 'STATUS_NOT_REALIZED',
    label: 'Non réalisé',
    color: 'red'
  },
  {
    value: STATUS_IN_PROGRESS,
    slug: 'STATUS_IN_PROGRESS',
    label: 'En cours',
    color: 'blue'
  },
  {
    value: STATUS_FINISHED,
    slug: 'STATUS_FINISHED',
    label: 'Terminé',
    color: 'green'
  },
  {
    value: STATUS_INTERRUPTED,
    slug: 'STATUS_INTERRUPTED',
    label: 'Interrompu',
    color: 'red'
  },
  {
    value: STATUS_PAUSED,
    slug: 'STATUS_PAUSED',
    label: 'En pause',
    color: 'yellow',
    textColor: 'black'
  },
  {
    value: STATUS_ARCHIVED,
    slug: 'STATUS_ARCHIVED',
    label: 'Archivé',
    color: 'red'
  },
  {
    value: STATUS_UNPROGRAMMED,
    slug: 'STATUS_UNPROGRAMMED',
    label: 'Déprogrammé',
    color: 'grey'
  },
  {
    value: STATUS_NOT_FINISHED,
    slug: 'STATUS_NOT_FINISHED',
    label: 'Non terminé',
    color: 'grey'
  }
]

/**
 * Liste des positions pour les services
 */
export const SERVICE_STATUS = {
  '?': INDETERMINATE_STATUS,
  ..._.keyBy(SERVICE_STATUS_LIST, 'value')
}

/**
 * Liste des positions pour les services
 */
export const SERVICE_STATUS_BY_SLUG = {
  '?': INDETERMINATE_STATUS,
  ..._.keyBy(SERVICE_STATUS_LIST, 'slug')
}

/**
 * Liste des status considérés comme actifs
 * @type {({color: string, label: string, value: number, textColor: string, slug: string}|{color: string, label: string, value: number, textColor: string, slug: string}|{color: string, label: string, value: number, slug: string}|{color: string, label: string, value: number, slug: string}|{color: string, label: string, value: number, slug: string})[]}
 */
export const SERVICES_STATUS_ACTIFS = SERVICE_STATUS_LIST.filter((s) => [STATUS_ARCHIVED, STATUS_UNPROGRAMMED].indexOf(s.value) === -1)

export const SERVICES_ERROR_MAX_DURATION = 'SERVICE_MAX_DURATION'
export const SERVICES_ERROR_REST_CONSECUTIVE = 'AGENT_REST_CONSECUTIVE'
export const SERVICES_ERROR_REST_SUNDAY = 'AGENT_REST_SUNDAY'
export const SERVICES_ERROR_RESTRICTION = 'AGENT_RESTRICTION'
export const SERVICES_ERROR_AGENT_SITE_FORBIDDEN = 'AGENT_SITE_FORBIDDEN'
export const SERVICES_ERROR_UNAVAILABLE = 'AGENT_UNAVAILABLE'
export const SERVICES_ERROR_ALREADY_HIRED = 'AGENT_ALREADY_HIRED'
export const SERVICES_ERROR_SPACE_11H = 'AGENT_SPACE_11H'
export const SERVICES_ERROR_REST_11H = 'AGENT_REST_11H'
export const SERVICES_ERROR_HOURS_LIMIT = 'AGENT_HOURS_LIMIT'
export const SERVICES_ERROR_AGENT_UNQUALIFIED = 'AGENT_UNQUALIFIED'
export const SERVICES_ERROR_AGENT_EXPIRED = 'AGENT_EXPIRED'
export const SERVICES_ERROR_AGENT_MAX_WEEKLY_HOURS = 'AGENT_MAX_WEEKLY_HOURS'
export const SERVICES_ERROR_AGENT_MIN_WEEKLY_REST = 'AGENT_MIN_WEEKLY_REST'

export const SERVICES_ERRORS = [
  {
    label: 'Vérification durée maximale des services',
    agencySettingsFeatureKey: 'checkServiceMaxDuration',
    value: SERVICES_ERROR_MAX_DURATION
  },
  {
    label: 'Vérification durée minimale entre les services',
    agencySettingsFeatureKey: 'checkAgentRestDuration',
    value: SERVICES_ERROR_SPACE_11H
  },
  {
    label: 'Vérification durée de temps de repos compensateur',
    agencySettingsFeatureKey: 'checkSpaceBetweenServices',
    value: SERVICES_ERROR_REST_11H
  },
  {
    label: 'Vérification des heures supplémentaires',
    agencySettingsFeatureKey: 'checkAgentOvertime',
    value: SERVICES_ERROR_HOURS_LIMIT
  },
  {
    label: `Vérification de l'engagement maximal hebdomadaire`,
    agencySettingsFeatureKey: 'checkAgentMaxWeeklyHours',
    value: SERVICES_ERROR_AGENT_MAX_WEEKLY_HOURS
  },
  {
    label: `Vérification de la durée minimale de repos hebdomadaire`,
    agencySettingsFeatureKey: 'checkAgentMinWeeklyRest',
    value: SERVICES_ERROR_AGENT_MIN_WEEKLY_REST
  },
  {
    label: 'Vérification des jours de repos consécutifs',
    agencySettingsFeatureKey: 'checkWeeklyConsecutiveRest',
    value: SERVICES_ERROR_REST_CONSECUTIVE
  },
  {
    label: 'Vérification du nombre de dimanche par mois',
    agencySettingsFeatureKey: 'checkMonthlySunday',
    value: SERVICES_ERROR_REST_SUNDAY
  },
  {
    label: 'Vérification de la qualification agent',
    agencySettingsFeatureKey: 'checkAgentQualified',
    value: SERVICES_ERROR_AGENT_UNQUALIFIED
  },
  {
    label: 'Vérification des expirations des agents',
    agencySettingsFeatureKey: 'checkAgentExpirations',
    value: SERVICES_ERROR_AGENT_EXPIRED
  },
  {
    label: 'Vérification des restrictions horaires des agents',
    agencySettingsFeatureKey: 'checkAgentRestriction',
    value: SERVICES_ERROR_RESTRICTION
  },
  {
    label: 'Vérification des interdictions de site',
    agencySettingsFeatureKey: 'checkAgentSiteForbidden',
    value: SERVICES_ERROR_AGENT_SITE_FORBIDDEN
  },
  {
    label: 'Vérification des indisponibilités agent',
    agencySettingsFeatureKey: 'checkAgentUnavailable',
    value: SERVICES_ERROR_UNAVAILABLE
  },
  {
    label: `Vérification affectations multiples d'un agent`,
    agencySettingsFeatureKey: 'checkAgentHired',
    value: SERVICES_ERROR_ALREADY_HIRED
  }
]
export const SERVICES_ERRORS_KEYED = _.keyBy(SERVICES_ERRORS, 'value')

export const SERVICES_ERROR_CHECK_OFF = 0
export const SERVICES_ERROR_CHECK_WARNING = 1
export const SERVICES_ERROR_CHECK_FORBIDDEN = 2

export const SERVICES_ERRORS_LVL = [
  {
    label: 'Désactiver',
    value: SERVICES_ERROR_CHECK_OFF
  },
  {
    label: 'Avertissement',
    value: SERVICES_ERROR_CHECK_WARNING
  },
  {
    label: 'Interdire',
    value: SERVICES_ERROR_CHECK_FORBIDDEN
  }
]

export const BREAK_STATUS = {
  '?': INDETERMINATE_STATUS,
  [BREAK_NOT_STARTED]: {
    label: 'En attente',
    color: 'yellow',
    textColor: 'black'
  },
  [BREAK_IN_PROGRESS]: {
    label: 'En cours',
    color: 'blue',
    icon: 'fa fa-pause'
  },
  [BREAK_NOT_FINISHED]: {
    label: 'Non terminée',
    color: 'warning',
    icon: 'fa fa-pause'
  },
  [BREAK_FINISHED]: {
    label: 'Terminée',
    color: 'positive',
    icon: 'fa fa-check'
  }
}
export const REPEAT_QUOTIDIENNE = 'quotidienne'
export const REPEAT_HEBDOMADAIRE = 'hebdomadaire'
export const REPEAT_MENSUELLE = 'mensuelle'
export const REPEAT_HOLIDAYS = 'holidays'

export const REPEAT_OPTIONS = [
  { value: REPEAT_QUOTIDIENNE, label: _.upperFirst(REPEAT_QUOTIDIENNE), prefix: 'Tous les', suffix: 'jour(s)' },
  {
    value: REPEAT_HEBDOMADAIRE,
    label: _.upperFirst(REPEAT_HEBDOMADAIRE),
    prefix: 'Toutes les',
    suffix: 'semaine(s)'
  },
  { value: REPEAT_MENSUELLE, label: _.upperFirst(REPEAT_MENSUELLE), prefix: 'Tous les', suffix: 'mois' },
  { value: REPEAT_HOLIDAYS, label: 'Jours fériés' }
]

export const SERVICES_DUPLICATE_PLANNING_ERROR_NO_START_AT = 'NO_START_AT'
export const SERVICES_DUPLICATE_PLANNING_ERROR_OUT_OF_BOUNDS = 'OUT_OF_BOUNDS'
export const SERVICES_DUPLICATE_PLANNING_ERROR_ALREADY_EXISTS = 'ALREADY_EXISTS'
export const SERVICES_DUPLICATE_PLANNING_ERRORS = [
  { value: SERVICES_DUPLICATE_PLANNING_ERROR_NO_START_AT, label: 'Services sans date de début' },
  { value: SERVICES_DUPLICATE_PLANNING_ERROR_OUT_OF_BOUNDS, label: 'Services hors bornes' },
  { value: SERVICES_DUPLICATE_PLANNING_ERROR_ALREADY_EXISTS, label: 'Services déjà existants' }
]
